import React, { useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { ImageIcon, ChevronLeft, ChevronRight } from 'lucide-react';
import img1 from "../../../assets/Images/p-slider/effervescent/1.png";
import img2 from "../../../assets/Images/p-slider/effervescent/2.png";
import img3 from "../../../assets/Images/p-slider/effervescent/3.png";
import img4 from "../../../assets/Images/p-slider/effervescent/4.png";
import img5 from "../../../assets/Images/p-slider/effervescent/5.png";
import img6 from "../../../assets/Images/p-slider/effervescent/6.png";
import img7 from "../../../assets/Images/p-slider/effervescent/7.png";
import img8 from "../../../assets/Images/p-slider/effervescent/8.png";
import img9 from "../../../assets/Images/p-slider/effervescent/9.png";
import img10 from "../../../assets/Images/p-slider/effervescent/10.png";
import img11 from "../../../assets/Images/p-slider/effervescent/11.png";
import img12 from "../../../assets/Images/p-slider/effervescent/12.png";
import img13 from "../../../assets/Images/p-slider/effervescent/13.png";
import img14 from "../../../assets/Images/p-slider/effervescent/14.png";
import img15 from "../../../assets/Images/p-slider/tablets/1.png";
import img16 from "../../../assets/Images/p-slider/tablets/2.png";
import img17 from "../../../assets/Images/p-slider/tablets/3.png";
import img18 from "../../../assets/Images/p-slider/tablets/4.png";
import img19 from "../../../assets/Images/p-slider/tablets/5.png";
import img20 from "../../../assets/Images/p-slider/tablets/6.png";
import img21 from "../../../assets/Images/p-slider/tablets/7.png";
import img22 from "../../../assets/Images/p-slider/tablets/8.png";
import img23 from "../../../assets/Images/p-slider/tablets/9.png";
import img24 from "../../../assets/Images/p-slider/tablets/10.png";
import img25 from "../../../assets/Images/p-slider/tablets/11.png";
import img26 from "../../../assets/Images/p-slider/tablets/12.png";
import img27 from "../../../assets/Images/p-slider/tablets/13.png";
import img28 from "../../../assets/Images/p-slider/tablets/14.png";
import img29 from "../../../assets/Images/p-slider/tablets/15.png";
import img30 from "../../../assets/Images/p-slider/tablets/16.png";
import img31 from "../../../assets/Images/p-slider/capsules/1.png";
import img32 from "../../../assets/Images/p-slider/capsules/2.png";
import img33 from "../../../assets/Images/p-slider/capsules/3.png";
import img34 from "../../../assets/Images/p-slider/capsules/4.png";
import img35 from "../../../assets/Images/p-slider/capsules/5.png";
import img36 from "../../../assets/Images/p-slider/capsules/6.png";
import img37 from "../../../assets/Images/p-slider/capsules/7.png";
import img38 from "../../../assets/Images/p-slider/capsules/8.png";
import img39 from "../../../assets/Images/p-slider/capsules/9.png";
import img40 from "../../../assets/Images/p-slider/capsules/10.png";
import img41 from "../../../assets/Images/p-slider/sachets/1.png";
import img42 from "../../../assets/Images/p-slider/sachets/2.png";
import img43 from "../../../assets/Images/p-slider/sachets/3.png";
import img44 from "../../../assets/Images/p-slider/sachets/4.png";
import img45 from "../../../assets/Images/p-slider/sachets/5.png";
import img46 from "../../../assets/Images/p-slider/sachets/6.png";
import img47 from "../../../assets/Images/p-slider/sachets/7.png";
import img48 from "../../../assets/Images/p-slider/sachets/8.png";
import img49 from "../../../assets/Images/p-slider/sachets/9.png";
import img50 from "../../../assets/Images/p-slider/sachets/10.png";
import img51 from "../../../assets/Images/p-slider/sachets/11.png";
import img52 from "../../../assets/Images/p-slider/sachets/12.png";
import img53 from "../../../assets/Images/p-slider/sachets/13.png";
import img54 from "../../../assets/Images/p-slider/powder/1.png";
import img55 from "../../../assets/Images/p-slider/powder/2.png";
import img56 from "../../../assets/Images/p-slider/powder/3.png";
import img57 from "../../../assets/Images/p-slider/powder/4.png";
import img58 from "../../../assets/Images/p-slider/powder/5.png";
import img59 from "../../../assets/Images/p-slider/powder/6.png";
import img60 from "../../../assets/Images/p-slider/powder/7.png";
import img61 from "../../../assets/Images/p-slider/powder/8.png";
import img62 from "../../../assets/Images/p-slider/powder/9.png";
import img63 from "../../../assets/Images/p-slider/powder/10.png";
import img64 from "../../../assets/Images/p-slider/powder/11.png";
import img65 from "../../../assets/Images/p-slider/powder/12.png";
import img66 from "../../../assets/Images/p-slider/powder/13.png";
import img67 from "../../../assets/Images/p-slider/powder/14.png";
import img68 from "../../../assets/Images/p-slider/powder/15.png";
import img69 from "../../../assets/Images/p-slider/powder/16.png";
import img70 from "../../../assets/Images/p-slider/powder/17.png";
import img71 from "../../../assets/Images/p-slider/powder/18.png";
import img72 from "../../../assets/Images/p-slider/powder/19.png";
import img73 from "../../../assets/Images/p-slider/powder/20.png";
import img74 from "../../../assets/Images/p-slider/powder/21.png";
import img75 from "../../../assets/Images/p-slider/powder/22.png";
import img76 from "../../../assets/Images/p-slider/powder/23.png";
import img77 from "../../../assets/Images/p-slider/powder/24.png";
import img78 from "../../../assets/Images/p-slider/powder/25.png";
import img79 from "../../../assets/Images/p-slider/powder/26.png";
import img80 from "../../../assets/Images/p-slider/powder/27.png";
import img81 from "../../../assets/Images/p-slider/powder/28.png";
import img82 from "../../../assets/Images/p-slider/powder/29.png";
import img83 from "../../../assets/Images/p-slider/powder/30.png";
import img84 from "../../../assets/Images/p-slider/powder/31.png";
import img85 from "../../../assets/Images/p-slider/powder/32.png";
import img86 from "../../../assets/Images/p-slider/powder/33.png";
import img87 from "../../../assets/Images/p-slider/powder/34.png";
import img88 from "../../../assets/Images/p-slider/powder/35.png";
import img89 from "../../../assets/Images/p-slider/powder/36.png";
import img90 from "../../../assets/Images/p-slider/powder/37.png";
import img91 from "../../../assets/Images/p-slider/powder/38.png";





const slugify = (str) =>
  String(str || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Keys MUST match the slugified `title` values used in ProductPage_New
// (e.g. "Effervescent Tablets" → "effervescenttablets").
// Replace `image: null` with a real URL when assets are ready.
const productsByCategory = {
  'Effervescent Tablets': [
    { id: 'ef1', name: 'Eff 1', image: img1 },
    { id: 'ef2', name: 'Eff 2', image: img2 },
    { id: 'ef3', name: 'Eff 3', image: img3 },
    { id: 'ef4', name: 'Eff 4', image: img4 },
    { id: 'ef5', name: 'Eff 5', image: img5 },
    { id: 'ef6', name: 'Eff 6', image: img6 },
    { id: 'ef7', name: 'Eff 7', image: img7 },
    { id: 'ef8', name: 'Eff 8', image: img8 },
    { id: 'ef9', name: 'Eff 9', image: img9 },
    { id: 'ef10', name: 'Eff 10', image: img10 },
    { id: 'ef11', name: 'Eff 11', image: img11 },
    { id: 'ef12', name: 'Eff 12', image: img12 },
    { id: 'ef13', name: 'Eff 13', image: img13 },
    { id: 'ef14', name: 'Eff 14', image: img14 },
    
  ],
  'Tablets': [
    { id: 'tb1', name: 'Tablet 1', image: img15 },
    { id: 'tb2', name: 'Tablet 2', image: img16 },
    { id: 'tb3', name: 'Tablet 3', image: img17 },
    { id: 'tb4', name: 'Tablet 4', image: img18 },
    { id: 'tb5', name: 'Tablet 5', image: img19 },
    { id: 'tb6', name: 'Tablet 6', image: img20 },
    { id: 'tb7', name: 'Tablet 7', image: img21 },
    { id: 'tb8', name: 'Tablet 8', image: img22 },
    { id: 'tb9', name: 'Tablet 9', image: img23 },
    { id: 'tb10', name: 'Tablet 10', image: img24 },
    { id: 'tb11', name: 'Tablet 11', image: img25 },
    { id: 'tb12', name: 'Tablet 12', image: img26 },
    { id: 'tb13', name: 'Tablet 13', image: img27 },
    { id: 'tb14', name: 'Tablet 14', image: img28 },
    { id: 'tb15', name: 'Tablet 15', image: img29 },
    { id: 'tb16', name: 'Tablet 16', image: img30 },
    
  ],
  'Capsules': [
    { id: 'cp1', name: 'Capsule 1', image: img31 },
    { id: 'cp2', name: 'Capsule 2', image: img32 },
    { id: 'cp3', name: 'Capsule 3', image: img33 },
    { id: 'cp4', name: 'Capsule 4', image: img34 },
    { id: 'cp5', name: 'Capsule 5', image: img35 },
    { id: 'cp6', name: 'Capsule 6', image: img36 },
    { id: 'cp7', name: 'Capsule 7', image: img37 },
    { id: 'cp8', name: 'Capsule 8', image: img38 },
    { id: 'cp9', name: 'Capsule 9', image: img39 },
    { id: 'cp10', name: 'Capsule 10', image: img40 },
  ],
  'Sachets': [
    { id: 'sc1', name: 'Sachet 1', image: img41 },
    { id: 'sc2', name: 'Sachet 2', image: img42 },
    { id: 'sc3', name: 'Sachet 3', image: img43 },
    { id: 'sc4', name: 'Sachet 4', image: img44 },
    { id: 'sc5', name: 'Sachet 5', image: img45 },
    { id: 'sc6', name: 'Sachet 6', image: img46 },
    { id: 'sc7', name: 'Sachet 7', image: img47 },
    { id: 'sc8', name: 'Sachet 8', image: img48 },
    { id: 'sc9', name: 'Sachet 9', image: img49 },
    { id: 'sc10', name: 'Sachet 10', image: img50 },
    { id: 'sc11', name: 'Sachet 11', image: img51 },
    { id: 'sc12', name: 'Sachet 12', image: img52 },
    { id: 'sc13', name: 'Sachet 13', image: img53 },

  ],
  'Powder': [
    { id: 'pp1', name: 'Protein 1', image: img54 },
    { id: 'pp2', name: 'Protein 2', image: img55 },
    { id: 'pp3', name: 'Protein 3', image: img56 },
    { id: 'pp4', name: 'Protein 4', image: img57 },
    { id: 'pp5', name: 'Protein 5', image: img58 },
    { id: 'pp6', name: 'Protein 6', image: img59 },
    { id: 'pp7', name: 'Protein 7', image: img60 },
    { id: 'pp8', name: 'Protein 8', image: img61 },
    { id: 'pp9', name: 'Protein 9', image: img62 },
    { id: 'pp10', name: 'Protein 10', image: img63 },
    { id: 'pp11', name: 'Protein 11', image: img64 },
    { id: 'pp12', name: 'Protein 12', image: img65 },
    { id: 'pp13', name: 'Protein 13', image: img66 },
    { id: 'pp14', name: 'Protein 14', image: img67 },
    { id: 'pp15', name: 'Protein 15', image: img68 },
    { id: 'pp16', name: 'Protein 16', image: img69 },
    { id: 'pp17', name: 'Protein 17', image: img70 },
    { id: 'pp18', name: 'Protein 18', image: img71 },
    { id: 'pp19', name: 'Protein 19', image: img72 },
    { id: 'pp20', name: 'Protein 20', image: img73 },
    { id: 'pp21', name: 'Protein 21', image: img74 },
    { id: 'pp22', name: 'Protein 22', image: img75 },
    { id: 'pp23', name: 'Protein 23', image: img76 },
    { id: 'pp24', name: 'Protein 24', image: img77 },
    { id: 'pp25', name: 'Protein 25', image: img78 },
    { id: 'pp26', name: 'Protein 26', image: img79 },
    { id: 'pp27', name: 'Protein 27', image: img80 },
    { id: 'pp28', name: 'Protein 28', image: img81 },
    { id: 'pp29', name: 'Protein 29', image: img82 },
    { id: 'pp30', name: 'Protein 30', image: img83 },
    { id: 'pp31', name: 'Protein 31', image: img84 },
    { id: 'pp32', name: 'Protein 32', image: img85 },
    { id: 'pp33', name: 'Protein 33', image: img86 },
    { id: 'pp34', name: 'Protein 34', image: img87 },
    { id: 'pp35', name: 'Protein 35', image: img88 },
    { id: 'pp36', name: 'Protein 36', image: img89 },
    { id: 'pp37', name: 'Protein 37', image: img90 },
    { id: 'pp38', name: 'Protein 38', image: img91 },
  ],
};

// Pre-compute slug → entry lookup once at module load.
const slugLookup = Object.entries(productsByCategory).reduce(
  (acc, [title, items]) => {
    acc[slugify(title)] = { title, items };
    return acc;
  },
  {}
);

const FALLBACK_TITLE = Object.keys(productsByCategory)[0];

const ProductCard = ({ product }) => (
  <div className="group relative shrink-0 snap-start w-[46%] xs:w-[40%] sm:w-[30%] md:w-[23%] lg:w-[18.5%] aspect-[3/4] rounded-xl bg-[#ebeae9] border border-[#355931]/10 overflow-hidden transition-all duration-500 hover:border-[#A4BE2C]/60 hover:shadow-[0_14px_30px_-18px_rgba(53,89,49,0.35)] hover:-translate-y-1">
    {product.image ? (
      <img
        src={product.image}
        alt={product.name}
        className="absolute inset-0 w-full h-full object-contain p-2 transition-transform duration-700 group-hover:scale-[1.06]"
        loading="lazy"
        style={{ imageRendering: 'auto' }}
      />
    ) : (
      <div className="absolute inset-0 flex flex-col items-center justify-center text-[#355931]/35 px-1">
        <ImageIcon className="w-9 h-9" strokeWidth={1.25} />
        <span className="mt-1.5 text-[10px] tracking-[0.2em] font-semibold text-center leading-tight">
          {product.name.toUpperCase()}
        </span>
      </div>
    )}
  </div>
);

const ProductsByZeon = () => {
  const scrollerRef = useRef(null);

  // Support whichever routing pattern is actually wired up:
  // 1) path param, e.g. /products/:category  or /products/:slug
  // 2) query string, e.g. /products?product=sachets
  const params = useParams();
  const [searchParams] = useSearchParams();

  const rawRequested =
    params.category ||
    params.slug ||
    params.name ||
    params.product ||
    searchParams.get('product');

  const requested = slugify(rawRequested);
  const match = slugLookup[requested];
  const activeTitle = match ? match.title : FALLBACK_TITLE;
  const items = match ? match.items : productsByCategory[FALLBACK_TITLE];

  const scrollByAmount = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8 * dir;
    el.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <section className="bg-white py-16 sm:py-20 px-4 sm:px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center">
          <h2 className="font-serif text-[#355931] text-3xl sm:text-4xl md:text-[40px] tracking-tight leading-tight">
            Products Manufactured By <span className="text-[#A4BE2C]">Nutra Like</span>
          </h2>
          <p className="text-gray-500 text-sm sm:text-base mt-3 tracking-wide">
            <span className="font-semibold text-[#355931]">{activeTitle}</span>
          </p>
          <div
            className="mx-auto mt-4 h-[2px] w-24"
            style={{
              background:
                'linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)',
            }}
          />
        </div>

        {/* Slider */}
        <div key={activeTitle} className="relative mt-10 pbz-fade">
          {/* Left arrow */}
          <button
            type="button"
            onClick={() => scrollByAmount(-1)}
            aria-label="Previous products"
            className="hidden sm:flex absolute -left-4 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-10 h-10 rounded-full bg-white border border-[#355931]/15 text-[#355931] shadow-md hover:bg-[#355931] hover:text-white transition-colors duration-300"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>

          {/* Right arrow */}
          <button
            type="button"
            onClick={() => scrollByAmount(1)}
            aria-label="Next products"
            className="hidden sm:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-10 h-10 rounded-full bg-white border border-[#355931]/15 text-[#355931] shadow-md hover:bg-[#355931] hover:text-white transition-colors duration-300"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          <div
            ref={scrollerRef}
            className="flex gap-3 sm:gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pbz-scrollbar-hide px-1 py-1"
          >
            {items.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pbz-fade-in {
          0%   { opacity: 0; transform: translateY(8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        .pbz-fade { animation: pbz-fade-in 450ms cubic-bezier(0.2, 0.8, 0.2, 1) both; }

        .pbz-scrollbar-hide {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .pbz-scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
};

export default ProductsByZeon;